import React, { useContext, useEffect, useState } from 'react';
import './PacsSection.css';
import { DefaultButton, IconButton, PrimaryButton, TextField } from '@fluentui/react';
import { t } from 'i18next';
import { ACTIONS, TOAST_TYPE } from '../../../../constants/Constants';
import { echoPacsNode } from '../../../../service/FirmServices';
import loaderContext from '../../../../context/loader/LoaderContext';
import toastContext from '../../../../context/toast/ToastContext';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';
import { color } from 'd3';
import CustomCheckBox from '../HeaderFileChecks/CustomCheckBox';

const ConfigurePacs = (props) => {
    
    const { ref, refAnnotation, setLoaderRunning, setLoaderAnnotationRunning } = useContext(loaderContext);

    const { showToastv2 } = useContext(toastContext);

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedList = [...props.pacsNodeList];
        updatedList[index][name] = value;
        props.setPacsNodeList(updatedList);
    };

    const handleCheckboxChange = (checked, index) => {
        const updatedList = [...props.pacsNodeList];
        updatedList[index].sendUncompressed = checked;
        props.setPacsNodeList(updatedList);
    };

    const handleAddPacs = () => {
        props.setPacsNodeList([...props.pacsNodeList, { name: '', description: '', aeTitle: '', hostname: '', port: '', active:true, sendUncompressed: false }]);
    };

    const handleDeletePacs = (index) => {
        const updatedList = [...props.pacsNodeList];
        if (updatedList[index].id) {
            updatedList[index].active = false;
        } else {
            updatedList.splice(index, 1);
        }
        props.setPacsNodeList(updatedList);
    };

    const handleEchoPacs = async(index) => {
        const pacs = props.pacsNodeList[index];
        console.log("echo pacs: ",pacs);

        if(pacs.name =='' || pacs.aeTitle =='' || pacs.port == '' || pacs.hostname == ''){
            showToastv2(TOAST_TYPE.INFO, "Please fill all required fields.");
            return;
        }

        setLoaderRunning(true);
        ref.current.continuousStart();

        const response = await echoPacsNode(pacs);
        console.log(response);
        
        if(response.status == 200 ) {
            if(response.data.data.status == "SUCCESS"){
                showToastv2(TOAST_TYPE.SUCCESS, "Echo successful! Connection to PACS node verified."); 
            }else{
                showToastv2(TOAST_TYPE.SUSPECT, "Echo failed! Unable to connect to PACS node.");
            }
        }
        else{
            showToastv2(TOAST_TYPE.ERROR, "Some error occured.");
        }
        setLoaderRunning(false);
        ref.current.complete();
    };

    useEffect(()=>{
        console.log("pacsList :",props.pacsNodeList);
    },[props.pacsNodeList])

    const requiredStyle = { color: 'red' };
    const iconButtonStyles = {
        root: { color: 'red' },
        rootHovered: { color: 'red' },
        rootPressed: { color: 'red' },
    };
    const tooltipStyle = {
        root: 'pacs-config-text',
      };
    return (
        <div className="tab-section">
            <section className="sectionA">
                <p style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                    marginBottom: "20px"
                }}> {t("hospital.configure-pacs")}
                </p>
            </section>

            {props.action !== ACTIONS.VIEW && (
                <>  
                {props.pacsNodeList.length > 0 && <>
                    <div className="pacs-table">
                        <div className="pacs-header">
                            <div className="pacs-item">{t("hospital.pacs.name")}<span style={requiredStyle}>*</span></div>
                            <div className="pacs-item">{t("hospital.pacs.description")}</div>
                            <div className="pacs-item">{t("hospital.pacs.ae-title")}<span style={requiredStyle}>*</span></div>
                            <div className="pacs-item">{t("hospital.pacs.host-name")}<span style={requiredStyle}>*</span></div>
                            <div className="pacs-item-port">{t("hospital.pacs.port")}<span style={requiredStyle}>*</span></div>
                            <div className="pacs-item-uncompressed">{t("hospital.pacs.send-uncompressed")}</div>
                            <div className="pacs-item">{t("hospital.pacs.action")}</div>
                        </div>
                        <div className="pacs-rows">
                            {props.pacsNodeList.map((pacs, index) => (
                                pacs.active && (
                                    <div key={index} className="pacs-row">
                                        <div className="pacs-item">
                                            <TextField
                                                name="name"
                                                placeholder={t("hospital.pacs.name")}
                                                value={pacs.name}
                                                onChange={(e) => handleInputChange(e, index)}
                                            />
                                        </div>
                                        <div className="pacs-item">
                                            <TextField
                                                name="description"
                                                placeholder={t("hospital.pacs.description")}
                                                value={pacs.description}
                                                onChange={(e) => handleInputChange(e, index)}
                                            />
                                        </div>
                                        <div className="pacs-item">
                                            <TextField
                                                name="aeTitle"
                                                placeholder={t("hospital.pacs.ae-title")}
                                                value={pacs.aeTitle}
                                                onChange={(e) => handleInputChange(e, index)}
                                            />
                                        </div>
                                        <div className="pacs-item">
                                            <TextField
                                                name="hostname"
                                                placeholder={t("hospital.pacs.host-name")}
                                                value={pacs.hostname}
                                                onChange={(e) => handleInputChange(e, index)}
                                            />
                                        </div>
                                        <div className="pacs-item-port">
                                            <TextField
                                                name="port"
                                                placeholder={t("hospital.pacs.port")}
                                                value={pacs.port}
                                                onChange={(e) => handleInputChange(e, index)}
                                            />
                                        </div>
                                        <div className="pacs-item-uncompressed">
                                            <CustomCheckBox
                                                parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                                                values={pacs.sendUncompressed}
                                                onChangeCustom={(e, checked) => handleCheckboxChange(checked, index)}
                                            />
                                        </div>

                                        <div className="pacs-item">
                                            <PrimaryButton onClick={() => handleEchoPacs(index)}  style={{ marginRight: '10px' }}>Echo</PrimaryButton>
                                            <IconButton
                                                iconProps={{ iconName: 'Delete' }}
                                                title="Delete"
                                                ariaLabel="Delete"
                                                onClick={() => handleDeletePacs(index)}
                                                styles={iconButtonStyles}
                                            />
                                        </div>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                    </>}
                    {props.errorState?.error && props.pacsNodeList.length > 0 && (
                        <div>
                            <span style={{ color: "red", fontSize: "12px", fontWeight: "600", marginLeft: "10px" }}>{props.errorState?.msg}</span>
                        </div>
                    )}
                    <PrimaryButton onClick={handleAddPacs} style={{ marginTop: '10px', marginLeft: "10px" }}>
                        Add New PACS
                    </PrimaryButton>
                </>
            )}

            {props.action === ACTIONS.VIEW && (
                <>
                    <div className="pacs-table">
                        {props.pacsNodeList?.filter(pacs => pacs.active).length !== 0 && ( <>
                        <div className="pacs-header">
                            <div className="pacs-item">{t("hospital.pacs.name")}</div>
                            <div className="pacs-item">{t("hospital.pacs.description")}</div>
                            <div className="pacs-item">{t("hospital.pacs.ae-title")}</div>
                            <div className="pacs-item">{t("hospital.pacs.host-name")}</div>
                            <div className="pacs-item-port">{t("hospital.pacs.port")}</div>
                            <div className="pacs-item">{t("hospital.pacs.send-uncompressed")}</div>
                        </div>
                        <div className="pacs-rows">
                            {props.pacsNodeList?.filter(pacs => pacs.active).map((pacs, index) => (
                                <div key={index} className="pacs-row">
                                    <div className="pacs-item"><CustomToolTipHost styles={tooltipStyle} content={pacs.name} id={"tooltip_"}>{pacs.name}</CustomToolTipHost></div>
                                    <div className="pacs-item"><CustomToolTipHost content={pacs.description} id={"tooltip_"}>{pacs.description || "-"}</CustomToolTipHost></div>
                                    <div className="pacs-item"><CustomToolTipHost content={pacs.aeTitle} id={"tooltip_"}>{pacs.aeTitle}</CustomToolTipHost></div>
                                    <div className="pacs-item"><CustomToolTipHost content={pacs.hostname} id={"tooltip_"}>{pacs.hostname}</CustomToolTipHost></div>
                                    <div className="pacs-item-port"><CustomToolTipHost content={pacs.port} id={"tooltip_"}>{pacs.port}</CustomToolTipHost></div>
                                    <div className="pacs-item">{pacs.sendUncompressed ? "Yes" : "No"}</div>
                                </div>
                            ))}
                        </div> </>)}
                        {props.pacsNodeList?.filter(pacs => pacs.active).length === 0 && (
                            <div className="form-heading">{t("hospital.pacs.no-pacs-available")}</div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
export default ConfigurePacs;